import * as z from "zod/v4";
import { InventoryViewType } from "./inventory-view-type";

export const deleteInventoryView = {
  name: "deleteInventoryView" as const,
  input: z.object({ viewType: InventoryViewType, name: z.string() }),
  output: z.object({ success: z.boolean() }),
};
